import { Input } from "reactstrap";
import "./style.scss";

export const Pagination = ({
  currentPage,
  setCurrentPage,
  pageSize,
  setPageSize,
  totalItems,
  realtimedropDownWrapper,
  realtimepaginationDropdown,
  realtimepaginationText,
  realtimepageDropdown,
  realtimepageText,
  realtimepagePrev,
  realtimepageNext,
}) => {

  const totalPages = Math.ceil(totalItems / pageSize);

  return (
    <div className="paginationContainer ">
      <div className="d-flex ">
        <div className={`dropDownWrapper ${realtimedropDownWrapper}`}>
          <Input
            type="select"
            className={`paginationDropdown ${realtimepaginationDropdown}`}
            value={pageSize}
            onChange={(e) => {
              setPageSize(parseInt(e.target.value));
              setCurrentPage(1);
            }}
          >
            <option>10</option>
            <option>20</option>
            <option>50</option>
            <option>100</option>
          </Input>
        </div>

        <div className={`paginationText ${realtimepaginationText}`}>
          {(currentPage - 1) * pageSize + 1} –{" "}
          {Math.min(currentPage * pageSize, totalItems)} of {totalItems} items
        </div>
      </div>

      <div className="d-flex">
        <div className={`pageDropdownWrap ${realtimepageDropdown}`}>
          <Input
            type="select"
            className="pageDropdown"
            value={currentPage}
            onChange={(e) => setCurrentPage(Number(e.target.value))}
          >
            {Array.from({ length: totalPages }, (_, i) => (
              <option key={i + 1}>{i + 1}</option>
            ))}
          </Input>
        </div>
        <div className={`pageText ${realtimepageText}`}>of {totalPages} pages</div>
        <div
          className={`pagePrev ${realtimepagePrev}`}
          onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
        >
          <i className="ri-arrow-left-s-fill" style={{ fontSize: "25px" }}></i>
        </div>
        <div
          className={`pageNext ${realtimepageNext}`}
          onClick={() =>
            setCurrentPage((prev) => Math.min(prev + 1, totalPages))
          }
        >
          <i className="ri-arrow-right-s-fill" style={{ fontSize: "25px" }}></i>
        </div>
      </div>
    </div>
  );
};
